import { connect } from 'react-redux';

import NewProfile from '../components/NewProfile';
import { openDialogWithFile } from '../redux/alert';
import { loadData } from '../redux/data';

import {
  tryUpdateAddress,
  tryUpdateInfo,
  tryUpdatePassword,
  tryUpdateMobile,
  tryUpdateProfilePic,
  tryUpdateImage,
  retrieveProfile,
} from '../redux/profile';
import { noPreferences } from '../redux/book';

const mapStateToProps = ({ auth, profile }) => ({
  ...auth,
  ...profile,
});

const mapDispatchToProps = dispatch => ({
  tryUpdateAddress: addresses => dispatch(tryUpdateAddress(addresses)),
  tryUpdateInfo: (field, value) => dispatch(tryUpdateInfo(field, value)),
  tryUpdatePassword: (password, confirmation) => dispatch(tryUpdatePassword(password, confirmation)),
  tryUpdateMobile: (field, value) => dispatch(tryUpdateMobile(field, value)),
  tryUpdateProfilePic: file => dispatch(tryUpdateProfilePic(file)),
  tryUpdateImage: (field, value) => dispatch(tryUpdateImage(field, value)),
  retrieveProfile: () => dispatch(retrieveProfile()),
  openDialogWithFile: (dialogType, file, caller) => dispatch(openDialogWithFile(dialogType, file, caller)),
  loadData: () => dispatch(loadData()),
  noPreferences: () => dispatch(noPreferences()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewProfile);



// WEBPACK FOOTER //
// ./src/containers/NewProfile.js